__turbopack_context__.v({
  "bottomBarContainer": "ShopBottomBar-module__witeGG__bottomBarContainer",
  "cartItemCount": "ShopBottomBar-module__witeGG__cartItemCount",
  "cartTotal": "ShopBottomBar-module__witeGG__cartTotal",
  "desktopLeftPanel": "ShopBottomBar-module__witeGG__desktopLeftPanel",
  "desktopMidPanel": "ShopBottomBar-module__witeGG__desktopMidPanel",
  "desktopRightPanel": "ShopBottomBar-module__witeGG__desktopRightPanel",
  "itemInfo": "ShopBottomBar-module__witeGG__itemInfo",
  "midPanelPhone": "ShopBottomBar-module__witeGG__midPanelPhone",
  "mobileTopRow": "ShopBottomBar-module__witeGG__mobileTopRow",
  "priceDetailsContainer": "ShopBottomBar-module__witeGG__priceDetailsContainer",
  "priceInfoContainer": "ShopBottomBar-module__witeGG__priceInfoContainer",
  "shopBottomBarSlideUp": "ShopBottomBar-module__witeGG__shopBottomBarSlideUp",
});
